import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { FacebookPostType } from 'redux/middleware/api/podcast-service';
import { facebookPagesSelector } from 'redux/modules/social';
import { MAX_CHARS_CAPTIONS_PREVIEW } from './constants';

function formatDescription(val: string) {
  if (typeof val !== 'string') return undefined;

  return val.substring(0, MAX_CHARS_CAPTIONS_PREVIEW);
}

export const facebookPagesOptionsSelector = createSelector(
  facebookPagesSelector,
  pages => {
    return pages.reduce((acc, page) => {
      acc.push({
        label: page.name,
        logo: page.imageUrl,
        value: page.pageId,
        pageAccessToken: page.pageAccessToken,
      });

      return acc;
    }, []);
  },
);

interface UseFacebookPostModalConfig {
  defaultDescription?: string;
  defaultPostType?: FacebookPostType;
  defaultFacebookPageId?: string;
}

export default function useFacebookPostModalSelector(
  config: UseFacebookPostModalConfig = {},
) {
  const { defaultDescription, defaultPostType, defaultFacebookPageId } = config;
  const pages = useSelector(facebookPagesOptionsSelector);

  return {
    defaultDescription: formatDescription(defaultDescription),
    defaultPostType,
    defaultUserId: defaultFacebookPageId ?? pages[0]?.value,
    pages,
  };
}
